import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { store } from '../../redux/store';
import { loginWithAuth0 } from '../../redux/modules/auth';

export default function AuthBootstrap(): JSX.Element | null {
  const auth0 = useAuth0();

  useEffect(() => {
    if (!auth0.isLoading) {
      store.dispatch<any>(loginWithAuth0(auth0));
    }
  }, [auth0.isLoading]); 

  return null;
}
